import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap';
import QuantidadePercentualSolicitacaoJustificativaStore from "../stores/QuantidadePercentualSolicitacaoJustificativaStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import classnames from 'classnames';
import {formatarPercentual} from "../../../utils/functions";

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM'];

@inject("store")
@DataWrapper
@observer
export class QuantidadePercentualSolicitacaoJustificativa extends Component {
    constructor(props) {
        super(props);
        this.controller = new QuantidadePercentualSolicitacaoJustificativaStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Quantidade e percentual solicitação por justificativa");
    }

    tooltipFormatter = (...options) => {
        let percentual = formatarPercentual(options[2].payload[options[1]+"-percentual"]);

        if(!percentual) {
            percentual = "0%";
        }
        
        return `${options[0]} / ${percentual}`;
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        { (
                            (this.controller.dadosSubstituicao && this.controller.dadosSubstituicao.length > 0) ||
                            (this.controller.dadosDemandaComplementar && this.controller.dadosDemandaComplementar.length > 0) ||
                            (this.controller.dadosProrrogacao && this.controller.dadosProrrogacao.length > 0)
                          ) &&
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                            className={classnames({ active: this.controller.activeTab === '1' })} >
                                            Substituição
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                            className={classnames({ active: this.controller.activeTab === '2' })} >
                                            Demanda Complementar
                                        </NavLink>
                                    </NavItem>
                                    {/*<NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('3'); }}
                                            className={classnames({ active: this.controller.activeTab === '3' })} >
                                            Prorrogação
                                        </NavLink>
                                    </NavItem>*/}
                                </Nav>
                                <TabContent activeTab={this.controller.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomBarChart dataKeys={["1-30", "31-90", ">90"]}
                                                        data={this.controller.dadosSubstituicao} legend={false} 
                                                        labelAxisX={"Justificativa"} labelAxisY={"Quantidade (dias)"} 
                                                        tooltipFormatter={this.tooltipFormatter} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomBarChart dataKeys={["1-30", "31-90", ">90"]}
                                                        data={this.controller.dadosDemandaComplementar} legend={false} 
                                                        labelAxisX={"Justificativa"} labelAxisY={"Quantidade (dias)"} 
                                                        tooltipFormatter={this.tooltipFormatter} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    /*
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomBarChart dataKeys={["1-10", "11-30", ">30"]}
                                                        data={this.controller.dadosProrrogacao} legend={false} 
                                                        labelAxisX={"Prorrogação"} labelAxisY={"Quantidade (dias)"} 
                                                        tooltipFormatter={this.tooltipFormatter} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    */
                                </TabContent>
                            </div>
                        }
                        { (
                            (this.controller.dadosSubstituicao && this.controller.dadosSubstituicao.length === 0) &&
                            (this.controller.dadosDemandaComplementar && this.controller.dadosDemandaComplementar.length === 0) &&
                            (this.controller.dadosProrrogacao && this.controller.dadosProrrogacao.length === 0)
                          ) &&
                            <span>Nenhum resultado encontrado</span>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
